// 영수증 헤더 컴포넌트
import { receiptTranslations } from './constants';
import { useLanguage } from '@/contexts/AppContext';

interface ReceiptHeaderProps {
  onBack: () => void;
}

export function ReceiptHeader({ onBack }: ReceiptHeaderProps) {
  // #522: 15 locale 전수 lookup — Locale 단일 출처 정합.
  const { locale } = useLanguage();
  const t = receiptTranslations[locale];

  return (
    <div className="fixed top-0 left-0 right-0 bg-primary z-50 h-[50px]">
      <div className="relative flex items-center justify-center w-full h-[50px] px-[20px]">
        {/* 뒤로가기 버튼 */}
        <button
          onClick={onBack}
          className="absolute left-[20px] flex items-center justify-center w-[32px] h-[32px]"
        >
          <svg className="w-[12px] h-[21px]" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
            <path
              d="M11.588 0.41098C11.4583 0.280705 11.3042 0.177346 11.1345 0.106823C10.9649 0.0363008 10.783 0 10.5993 0C10.4156 0 10.2337 0.0363008 10.0641 0.106823C9.89442 0.177346 9.74031 0.280705 9.61059 0.41098L0.326717 9.71087C0.223149 9.8144 0.140982 9.93738 0.0849197 10.0728C0.0288573 10.2082 0 10.3533 0 10.4999C0 10.6464 0.0288573 10.7916 0.0849197 10.9269C0.140982 11.0623 0.223149 11.1853 0.326717 11.2888L9.61059 20.5887C10.158 21.1371 11.0406 21.1371 11.588 20.5887C12.1354 20.0404 12.1354 19.1562 11.588 18.6079L3.49955 10.4943L11.5992 2.38063C12.1354 1.84345 12.1354 0.948157 11.588 0.41098Z"
              fill="white"
            />
          </svg>
        </button>

        {/* 타이틀 */}
        <p
          className="font-['Noto_Sans:Bold',_'Noto_Sans_KR:Bold',_sans-serif] font-bold text-[18px] text-white tracking-[-0.36px] text-center uppercase"
          style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
        >
          {t.title}
        </p>
      </div>
    </div>
  );
}
